/** In-memory access token — not persisted to localStorage (reduces XSS exfiltration window). */
let accessToken = null;
let refreshInFlight = null;

export function getStoredAccessToken() {
  return accessToken;
}

export function setStoredAccessToken(token) {
  accessToken = token || null;
}

export function clearStoredAccessToken() {
  accessToken = null;
}

export function getRefreshInFlight() {
  return refreshInFlight;
}

export function setRefreshInFlight(promise) {
  refreshInFlight = promise;
}

export function clearRefreshInFlight() {
  refreshInFlight = null;
}
